
export default function WhoThisIsFor() {
  const forYou = [
    'You\'re a serious learner',
    'You want to build teams',
    'You seek structure and mentorship',
    'You\'re interested in health, impact, and income',
  ];

  const notForYou = [
    'You\'re looking for shortcuts',
    'You have a get-rich-quick mindset',
    'You\'re inconsistent',
    'You\'re unwilling to be coached',
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Who This Is For
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-green-50 rounded-xl p-8 border-2 border-green-500">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-green-500 rounded-full">
                <i className="ri-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 ml-4">
                This Is For You If:
              </h3>
            </div>
            <ul className="space-y-4">
              {forYou.map((item, index) => (
                <li key={index} className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-green-500 text-xl"></i>
                  </div>
                  <span className="text-gray-700 ml-3 text-base">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-red-50 rounded-xl p-8 border-2 border-red-500">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-red-500 rounded-full">
                <i className="ri-close-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 ml-4">
                This Is NOT For You If:
              </h3>
            </div>
            <ul className="space-y-4">
              {notForYou.map((item, index) => (
                <li key={index} className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-close-circle-fill text-red-500 text-xl"></i>
                  </div>
                  <span className="text-gray-700 ml-3 text-base">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
